const navigationToggle = document.querySelectorAll('.navigation__toggle, .navigation__trigger');
const navigationOverlay = document.getElementById('site-navigation');
const hamburgerButton = document.querySelector('.hamburger');

const toggleHamburgerActiveClassName = 'hamburger--active';
const navigationActiveClassName = 'navigation__overlay--active';

const triggerToggleButtonStateChange = (isActive = true) => {
    navigationToggle.forEach(toggle => {
        if (isActive == true) {
            hamburgerButton.classList.remove(toggleHamburgerActiveClassName);
            toggle.setAttribute('aria-expanded', 'false');
        } else {
            hamburgerButton.classList.add(toggleHamburgerActiveClassName);
            toggle.setAttribute('aria-expanded', 'true');
        }
    });
};

if (navigationToggle) {
    navigationToggle.forEach(toggle => {
        toggle.addEventListener('click', function () {
            const isActive = toggle.getAttribute('aria-expanded') === 'true';

            if (isActive) {
                navigationOverlay.classList.remove(navigationActiveClassName);
                navigationOverlay.setAttribute('aria-hidden', 'true');
                triggerToggleButtonStateChange(true);
            } else {
                navigationOverlay.classList.add(navigationActiveClassName);
                navigationOverlay.setAttribute('aria-hidden', 'false');
                triggerToggleButtonStateChange(false);
            }
        });
    });
}

document.addEventListener('keydown', e => {
    const isEscape = e.key === 'Escape';

    if (isEscape && navigationToggle[0].getAttribute('aria-expanded') === 'true') {
        navigationToggle[0].click();
    }
});
